import { useContext } from "react";
import { FarmContext } from "@/src/context";

export const useFarms = () => useContext(FarmContext);